import { addTmsTrackingForChooseMyStoreButton } from "./tracking-tms";
import { initContextPopover } from "./context-popover";
import { initValidContextPopover } from "./valid-context-popover";
export function addContextHeaderEvent() {
  const contextHeaderSelector = document.querySelector(`[data-selectorid='context-header']`);
  const storeHeaderSelector = contextHeaderSelector.querySelector(".js-context-store-name-button");
  const buttonLocation = "Header";
  const openContextLayerEvent = new CustomEvent("openStoreContextLayer", {
    detail: {
      funnel_name: buttonLocation
    }
  });
  const isBuM = contextHeaderSelector.getAttribute("data-isbum") === "true";
  if (!isBuM) {
    initContextPopover();
    initValidContextPopover();
  }
  storeHeaderSelector.addEventListener('click', () => {
    addTmsTrackingForChooseMyStoreButton("Choose my store", "Contextualisation", buttonLocation);
    window.dispatchEvent(openContextLayerEvent);
  });
}